import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {FmtItemState, FmtItem, FTABillOfMaterialsDate} from "./types";
import {RootState} from "@/store/types";
import {getFTABillOfMaterials} from "@/services/fta_bill_of_materials";

export const state: FmtItemState = {
    fmtItems: [],
    selectedItemCode: "",
    date_filter: {
      date: ''
    },
    loaded: false
}

const actions: ActionTree<FmtItemState, RootState> = {
  async GET_FTA_BILL_OF_MATERIALS(_, payload) {
    return await getFTABillOfMaterials(payload);
  }
}

const mutations: MutationTree<FmtItemState> = {
  SET_FTA_ITEMS(state, items: FmtItem[]) {
    state.fmtItems = items;
  },
  SET_SELECTED_FTA_ITEM(state, code:string) {
    state.selectedItemCode = code;
  },
  SET_FTA_ITEM_DATE(state, date: FTABillOfMaterialsDate) {
    state.date_filter = date;
  },
  SET_LOADING_STATUS(state, status: boolean) {
    state.loaded = status;
  },
  RESET_FTA_ITEM(state) {
    state.fmtItems = []
  },
}

const getters: GetterTree<FmtItemState, RootState> = {
  FTA_BILL_OF_MATERIALS_ITEMS(state): FmtItem[] {
    const {fmtItems} = state;
    return [...fmtItems];
  },
  FTA_BILL_OF_MATERIALS_LOADING_STATUS(state) : boolean {
    const {loaded} = state;
    return loaded;
  },
  FTA_BILL_OF_MATERIALS_MONTH(state): FTABillOfMaterialsDate {
    const {date_filter} = state;
    return {...date_filter};
  },
  SELECTED_FTA_ITEM(state): string {
    const {selectedItemCode} = state;
    return selectedItemCode;
  }
}

export const fta_bill_of_materials: Module<FmtItemState, RootState> = {
  state,
  actions,
  getters,
  mutations
}